import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

export default function SchedulingDraftStatus({ draft, generatedAt, intl }) {
  if (!draft) return null;

  const applied = draft.status === "applied";
  const statusLabel = intl.messages?.[`scheduling.draft.status.${draft.status}`]
    ? intl.formatMessage({ id: `scheduling.draft.status.${draft.status}` })
    : draft.status;

  return (
    <Stack spacing={1.25}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <Typography variant="h6">
          {intl.formatMessage({ id: "scheduling.draft.version" }, { version: draft.version })}
        </Typography>
        <Chip size="small" color={applied ? "success" : "info"} variant="outlined" label={statusLabel} />
        {generatedAt && (
          <Typography variant="caption" color="text.secondary">
            {intl.formatMessage(
              { id: "scheduling.draft.generated" },
              {
                date: intl.formatDate(generatedAt),
                time: intl.formatTime(generatedAt),
              },
            )}
          </Typography>
        )}
      </Stack>
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage(
          { id: applied ? "scheduling.draft.applied" : "scheduling.draft.ready" },
          { version: draft.version },
        )}
      </Typography>
      {!applied && draft.expires_at && (
        <Stack direction="row" spacing={0.75} alignItems="center">
          <AccessTimeOutlinedIcon fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            {intl.formatMessage(
              { id: "scheduling.draft.expires" },
              {
                date: intl.formatDate(draft.expires_at),
                time: intl.formatTime(draft.expires_at),
              },
            )}
          </Typography>
        </Stack>
      )}
      <Typography variant="caption" color="text.secondary">
        {intl.formatMessage({ id: "scheduling.draft.sessionOnly" })}
      </Typography>
    </Stack>
  );
}
